<template>
  <div>
    <div
      v-if="previewId || podbeanId"
      :preview-id="previewId"
    >
      <div v-if="currentPage === 1">
        <div
          v-if="courseTest"
          class="h-40 relative rounded-xl"
          :style="`background-image: url(${thumbnail});`"
          style="width: 400px; height: 260px;"
        >
          <div class="rounded-xl w-full h-full bg-gradient-to-t from-gray-800 via-transparent to transparent flex justify-between items-end">
            <slot name="ratings" />
          </div>
        </div>
        <img
          v-else
          :src="thumbnail"
          :alt="title"
        />
      </div>
      <div v-if="currentPage === 2 && previewId">
        <course-kaltura-player
          v-if="previewId"
          :preview-id="previewId"
        />
      </div>
      <div v-else-if="currentPage === 2 && podbeanId">
        <iframe
          title="Audio M4A"
          allowtransparency="true"
          class="w-80 md:w-96"
          height="300"
          style="border: none; min-width: min(100%, 300px);"
          scrolling="no"
          data-name="pb-iframe-player"
          :src="`https://www.podbean.com/player-v2/?i=${podbeanId}-pb&from=pb6admin&pbad=0&square=1&share=1&download=0&rtl=0&fonts=Arial&skin=1&font-color=auto&logo_link=episode_page&btn-skin=3267a3&size=300`"
          allowfullscreen=""
        />
      </div>
      <div class="flex items-center justify-center pb-4">
        <t-pagination
          v-model="currentPage"
          :items-per-page="1"
          :total-items="2"
          :default-page="1"
          button-class="rounded-full w-6 h-6 p-0"
          icon-class="text-xs mb-1"
          :show-number-list="false"
          @page-changed="handlePageChange"/>
      </div>

      <div v-if="podbeanId && courseTest">
        <l-podcast-social-icons />
      </div>
    </div>
    <div v-else>
      <div
        v-if="courseTest"
        class="h-40 relative rounded-xl"
        :style="`background-image: url(${thumbnail});`"
        style="width: 370px; height: 260px;"
      >
        <div class="rounded-xl w-full h-full bg-gradient-to-t from-gray-800 via-transparent to transparent flex justify-between items-end">
          <slot name="ratings" />
        </div>
      </div>
      <img
        v-else
        :src="thumbnail"
        :alt="title"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    previewId: {
      type: String,
      required: false,
      default: null,
    },
    podbeanId: {
      type: String,
      required: false,
      default: null,
    },
    courseTest: {
      type: Boolean,
      default: false,

    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    handlePageChange(newPage) {
      console.log('Page changed to:', newPage);
      this.currentPage = newPage;
    },
  },

};
</script>
